import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../../actions/blocks.action'
import { destroyMultimediaBlock } from 'api/administration/blocks/Destroy'
import lessonBlocksList from 'api/administration/blocks/List'
import I18n from 'i18n'
import { SuccessToast, ErrorToast } from 'components/ui/toast/toastsTemplates'

async function getList(lessonId: number) {
  return await lessonBlocksList(lessonId)
}

async function handleDestroyMultimediaBlock(multimediaBlockId: number) {
  return await destroyMultimediaBlock(multimediaBlockId)
}

function* destroyMultimediaBlockEffectSaga(action: any) {
  try {
    const {
      payload: { multimediaBlockId, lessonId },
    } = action
    yield call(handleDestroyMultimediaBlock, multimediaBlockId)
    const data = yield call(getList, lessonId)
    yield put(fromActions.Actions.getLessonBlocksListSuccess(data))
    SuccessToast(I18n.t('administration.toastMessages.deleteSuccess'))
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.deleteError'))
    console.log('error: ', error)
  }
}

export function* destroyMultimediaBlockWatcherSaga() {
  yield takeLatest(fromActions.DESTROY_MULTIMEDIA_BLOCK, destroyMultimediaBlockEffectSaga)
}
